module.exports = __webpack_public_path__ + "static/media/calendaricon.56d8c339.svg";